// extracted by mini-css-extract-plugin
export default {"card":"NoSelected_card__xRHqV","image":"NoSelected_image__slktH","createNew":"NoSelected_createNew__r73Gj"};